import { ENDPOINTS } from 'config/endpoints';
import { useMutation } from '@tanstack/react-query';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import CronoError from 'crono-fe-common/types/error';
import IntegrationType from 'crono-fe-common/types/enums/integrationType';
import { getLabelForIntegrationType } from 'crono-fe-common/utils/crm-utils';

export type HubspotOauthCode = {
  code: string;
};

const integrationLabel = getLabelForIntegrationType(IntegrationType.HUBSPOT);

const hubspotAuthCallback = (data: HubspotOauthCode) => {
  const request: Request = {
    url: ENDPOINTS.hubspot.authCallback,
    config: {
      method: 'post',
      data: data,
    },
  };

  return client(request);
};

const useHubspotAuthCallback = () =>
  useMutation<Response<null>, CronoError, HubspotOauthCode>(
    hubspotAuthCallback,
    {
      meta: {
        successMessage: `Successfully logged into ${integrationLabel}`,
        errorMessage: 'Error while connecting with the CRM',
      },
    },
  );

export default useHubspotAuthCallback;
